import clsx from "clsx";
import { ArrowLeftRight, Heart, MessageSquare, User } from "lucide-react";
import { NavLink } from "react-router-dom";

const tabs = [
  { path: "/discover", label: "Discover", icon: ArrowLeftRight, testId: "bottom-tab-bar-discover" },
  { path: "/liked-you", label: "Liked you", icon: Heart, testId: "bottom-tab-bar-liked-you" },
  { path: "/matches", label: "Messages", icon: MessageSquare, testId: "bottom-tab-bar-matches" },
  { path: "/profile", label: "Profile", icon: User, testId: "bottom-tab-bar-profile" },
] as const;

/**
 * Bottom tab bar for the main app (Discover, Liked you, Messages, Profile).
 * Shown in MainLayout after onboarding. Active tab is highlighted in pink.
 */
export function BottomTabBar() {
  return (
    <nav
      className={clsx(
        "fixed bottom-0 left-0 right-0 z-[60]",
        "min-h-bottom-tab-bar",
        "bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]",
        "pt-3 pb-[env(safe-area-inset-bottom)]",
        "flex justify-around items-center"
      )}
      data-testid="bottom-tab-bar"
      aria-label="Main navigation"
    >
      {tabs.map(({ path, label, icon: Icon, testId }) => (
        <NavLink
          key={path}
          to={path}
          aria-label={label}
          aria-current="page"
          data-testid={testId}
          className={({ isActive }) =>
            clsx(
              "flex flex-col items-center justify-center p-2 rounded-lg transition-colors",
              isActive ? "text-pink-600" : "text-gray-500 hover:text-gray-700"
            )
          }
        >
          {({ isActive }) => (
            <Icon className={clsx("size-7", isActive ? "text-pink-600" : "text-gray-500")} aria-hidden />
          )}
        </NavLink>
      ))}
    </nav>
  );
}
